<template>
  <div class="product-wrapper">
    <banner page="productList" :height="460"></banner>
    <search-filter
      :productCount="totalCount"
      :menuId="menuId > 0 ? menuId : 0"
      :searchParams="searchParams"
    ></search-filter>
    <div class="container">
      <div class="product-not-data" v-if="productList.length < 1">
        <Icon type="md-warning" />抱歉，没有找到相关的数据！
      </div>
      <div v-else class="product-total">共查询到{{ totalCount }}门课程</div>
      <ul class="product-list">
        <li v-for="(product, index) in productList" :key="index">
          <div class="can-integral" v-if="product.isIntegral"></div>
          <router-link
            :to="{
              name: product.type === 1 ? 'MajorDetail' : 'CourseDetail',
              params: { id: product.productId },
            }"
            :title="product.name"
            class="product-item"
          >
            <div class="product-item-image">
              <img
                v-lazy="concatImageUrl(product.image, 280, 160)"
                :alt="product.name"
              />
              <div class="can-live" v-if="product.hasLive"></div>
            </div>
            <h2 class="product-item-title">{{ product.name }}</h2>
            <span class="product-item-type">{{ product.specialTypeName }}</span>
            <span class="product-item-price">
              <s
                v-show="
                  formatPrice(product.discountPrice, product.price)[1] !== '-1'
                "
                >¥{{ formatPrice(product.discountPrice, product.price)[1] }}</s
              >
              <span
                v-show="
                  formatPrice(product.discountPrice, product.price)[0] !== '-1'
                "
                ><i>¥</i
                >{{
                  formatPrice(product.discountPrice, product.price)[0]
                }}</span
              >
            </span>
          </router-link>
        </li>
      </ul>
      <div class="product-page" v-show="totalCount > 0 && menuId == 0">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import SearchFilter from "../../components/mall/SearchFilter";
import Banner from "../home/Banner";
import { mall } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      menuId: 0,
      categoryId: 0,
      labelId: 0,
      majorId: 0,
      typeId: 0,
      specialId: 0,
      addressId: 0,
      keywords: "",
      productList: [],
      pageIndex: 1,
      pageSize: 28,
      totalCount: 0,
      searchParams:{}
    };
  },
  mounted() {
    this.initQueryValue();
    this.setMetaData("精品课程");
  },
  watch: {
    $route(to, from) {
      this.changeQueryValue(to, from);
    },
  },
  methods: {
    initQueryValue() {
      console.log('initQueryValue');
      this.menuId = this.$route.params.id ?? 0;
      this.categoryId = this.$route.query.c ?? 0;
      this.labelId = this.$route.query.l ?? 0;
      this.majorId = this.$route.query.m ?? 0;
      this.typeId = this.$route.query.t ?? 0;
      this.specialId = this.$route.query.s ?? 0;
      this.keywords = this.$route.query.k ?? "";
      this.addressId = this.$route.query.a ?? 0;
      this.pageIndex = 1;
      if (this.menuId > 0) {
        this.getDiyData();
      } else {
        this.getData();
      }
    },
    changeQueryValue(to, from) {
      if (to.params.id !== from.params.id) {
        this.menuId = to.params.id ?? 0;
      }
      if (to.query.c !== from.query.c) {
        this.categoryId = to.query.c;
      }
      if (to.query.l !== from.query.l) {
        this.labelId = to.query.l;
      }
      if (to.query.m !== from.query.m) {
        this.majorId = to.query.m;
      }
      if (to.query.t !== from.query.t ) {
        this.typeId = to.query.t;
      }
      if (to.query.s !== from.query.s) {
        this.specialId = to.query.s;
      }
      if (to.query.k !== from.query.k) {
        // 点击地区不清空搜索框
        if(!(to.query.a && this.keywords)){
          this.keywords = to.query.k;
        }
      }
      if (to.query.a !== from.query.a && !to.query?.k) {
        this.addressId = to.query.a;
      }
      if(!to.query?.k){
        // console.log('to.query.categoryId',to.query.c);
        // console.log('to.query.typeId',to.query.t);
        this.searchParams = {
          addressId: to.query.a,
          // typeId: to.query.t,
          // specialId: to.query.s,
          // labelId: to.query.l,
          // majorId: to.query.m,
          // categoryId: to.query.c,
        }
      }
      this.pageIndex = 1;
      if (this.menuId > 0) {
        this.getDiyData();
      } else {
        this.getData();
      }
    },
    getData() {
      mall
        .getProductList({
          agencyId: this.siteConfig.agencyId,
          typeId: this.categoryId,
          labelId: this.labelId,
          specialId: this.typeId,
          specialTypeId: this.specialId,
          majorId: this.majorId,
          keywords: this.keywords,
          page: this.pageIndex,
          pageSize: this.pageSize,
          addressId: this.addressId,
        })
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            const result = res.data.pageInfo;
            this.productList = result.list;
            this.totalCount = result.total;
          }
        });
    },
    getDiyData() {
      mall
        .getProductDiyList({
          agencyId: this.siteConfig.agencyId,
          menuId: this.menuId,
          typeId: this.categoryId,
          labelId: this.labelId,
          majorId: this.majorId,
        })
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.productList = res.data;
            this.totalCount = res.data.length;
          }
        });
    },
    changePage(page) {
      this.scrollTop();
      this.pageIndex = page;
      this.getData();
    },
  },
  components: {
    SearchFilter,
    Banner,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.product-wrapper {
  background: url("../../assets/images/v3/product-list-bg.png") no-repeat bottom;
}
// .product-banner {
//   width: 100%;
//   height: 460px;
//   background: url("../../assets/images/v3/product-banner.png") no-repeat top;
// }

.product-not-data {
  text-align: center;
  font-size: 2.2rem;
  line-height: 1;
  color: orange;
  min-height: 150px;
  padding: 30px 0;
  i {
    font-size: 2.4rem;
    margin-right: 10px;
  }
}
.product-total {
  text-align: right;
  padding: 20px 10px;
  color: #248cfc;
  font-size: 16px;
}
.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px auto;
  li {
    padding: 0 10px 20px 10px;
    flex: 0 0 300px;
    width: 300px;
    position: relative;
    .transTime(0.2s);
    &:hover {
      transform: translateY(-10px);
    }
    .can-integral {
      position: absolute;
      left: 10px;
      top: 0px;
      width: 80px;
      height: 20px;
      background: url(../../assets/images/integral.png) no-repeat;
      z-index: 3;
    }
    .can-live {
      .can-live();
      left: -1px;
      bottom: 0px;
    }
    .product-item {
      display: block;
      position: relative;
      background: #fff;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
      padding-bottom: 16px;

      .product-item-image {
        position: relative;
        width: 280px;
        height: 160px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .product-item-type {
        color: #8e8e8e;
        font-size: 14px;
        height: 14px;
        display: inline-block;
        padding-left: 10px;
      }
      .product-item-title {
        padding: 15px 10px 5px 10px;
        font-size: 1.6rem;
        color: #333;
        .ellipsis();
      }
      .product-item-price {
        float: right;
        font-size: 16px;
        font-weight: bold;
        color: #de4848;
        padding-right: 10px;
        i {
          font-style: normal;
          font-size: 12px;
        }
        s {
          margin-right: 8px;
          color: #999;
          font-size: 12px;
        }
      }
    }
  }
}
.product-page {
  text-align: center;
  padding: 15px 0 20px 0;
}
</style>
